<template>
  <div id="app">
    <router-view :key="$router.currentRoute.fullPath"/>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'App',
  data () {
    return {}
  },
  computed: {
    ...mapState({
      config: state => state.config.config
    })
  },
  created: function () {
    if (!this.config) {
      this.fetchConfig({}).then(
        res => {
          if (res.code == 10000) {
            document.title = res.result.config_list.site_name
          } else {
            Toast(res.message)
          }
        },
        error => {
          Toast(error.message)
        }
      )
    }
  },
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    })
  }
}
</script>
